import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=a31ebc68&scoped=true&"
import script from "./LoginPage.js?vue&type=script&lang=js&"
export * from "./LoginPage.js?vue&type=script&lang=js&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=a31ebc68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31ebc68",
  null
  
)

export default component.exports